import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '../components/HelloWorld';
import NoRight from '../components/noRight';
import Login from '../components/login';
import PrintPreview from '../components/printPreview';
import MainView from '../components/mainView';
//教务
import Index from '../components/index';
import Task from '../components/task';
import Class from '../components/class';
import Dashboard from '../components/dashboard';
import DashboardContent from '../components/dashboardContent';
import DashboardContentPC from '../components/dashboardContentPC';
import ClassDetails from '../components/classDetails';
import OpenClassMessage from '../components/openClassMessage';
import StudentList from '../components/studentList';
import TrainingSchedule from '../components/trainingSchedule';
import HomeworkArrange from '../components/homeworkArrange';
import ClassResources from '../components/classResources';
import HomeworkManage from '../components/homeworkManage';
import AttendanceSituation from '../components/attendanceSituation';
import TeachingEvaluation from '../components/teachingEvaluation';
import ClazzEvaluation from '../components/clazzEvaluation';
import HomeworkScore from '../components/homeworkScore';
import ClassAlbum from '../components/classAlbum';
import QrCode from '../components/qrCode';
import CourseStatistics from '../components/courseStatistics';
import ClassRoom from '../components/classRoom';
import Message from '../components/message';
import MessageDetails from '../components/messageDetails';
import WriteMsg from '../components/writeMsg';
import Setting from '../components/setting';
import PlaceSetting from '../components/placeSetting';
import SuggestionsSetting from '../components/suggestionsSetting';
import QuestionnaireSetting from '../components/questionnaireSetting';
import MsgSetting from '../components/msgSetting';
import TeacherManage from '../components/teacherManage';
import TeacherManageOutside from '../components/teacherManageOutside';
import TeacherManageParent from '../components/teacherManageParent';
import WorkloadStatistics from '../components/workloadStatistics';
import StudyTrainingDetailsStatistics from '../components/studyTrainingDetailsStatistics';
import ClassStatistics from '../components/classStatistics';
import TopicFind from '../components/topicFind';
import AttendanceTeacher from '../components/attendanceTeacher';
import ExternalTeacherStatistics from '../components/externalTeacherStatistics';
import TeachingEvaluationAll from '../components/teachingEvaluationAll';
import TeachingEvaluationOutside from '../components/teachingEvaluationOutside';
import TrainingManage from '../components/trainingManage';
import AttendanceManagement from '../components/attendanceManagement/attendanceManagement';
import AttendanceSchedule from '../components/attendanceManagement/attendanceSchedule';

//学员
import IndexStu from '../components/indexStu';
import TaskStu from '../components/taskStu';
import HomeworkManageStu from '../components/homeworkManageStu';

//批改老师
import IndexTea from '../components/indexTea';
import TaskTea from '../components/taskTea';
import HomeworkManageTea from '../components/homeworkManageTea';
import CourseManageTea from '../components/courseManageTea';
import CourseManage from '../components/courseManage';
import HomeworkManageDetailsTea from '../components/homeworkManageDetailsTea';
import ClassTea from '../components/teacherClass/classTea';
import ClassDetailsTea from '../components/teacherClass/classDetailsTea';
import OpenClassMessageTea from '../components/teacherClass/openClassMessageTea';
import StudentListTea from '../components/teacherClass/studentListTea';
import TrainingScheduleTea from '../components/teacherClass/trainingScheduleTea';
import HomeworkScoreTea from '../components/teacherClass/homeworkScoreTea';
import QrCodeTea from '../components/teacherClass/qrCodeTea';
import ResearchFeedback from '../components/researchFeedback';
import ResearchFeedback1 from '../components/researchFeedback1';

//餐饮
import CateringMenu from '../components/cateringMenu';
import CateringToday from '../components/cateringToday';
import CateringRecord from '../components/cateringRecord';
import CateringQrcode from '../components/cateringQrcode';

import Library from '../components/library';
import LessonLive from '../components/lessonLive';
import Research from '../components/research';
import ResearchTeacher from '../components/researchTeacher';

//科研部
import ResearchCollection from '../components/researchCollection';




Vue.use(Router);

import configData from '../json/data';
let leaderUserCode = configData.leaderUserCode;
let easUserCode = configData.easUserCode;
let teacherClassUserCode = configData.teacherClassUserCode;
let teacherUserCode = configData.teacherUserCode;
let studentUserCode = configData.studentUserCode;
let manageCode = configData.manageCode;
let cateringCode = configData.cateringCode;

export default new Router({
  routes: [
    {//测试页
      path: '/helloWorld', name: 'HelloWorld', component: HelloWorld,
      meta: {
        auth: false,
      }
    },{//无权页
      path: '/noRight', name: 'NoRight', component: NoRight,
      meta: {
        auth: false,
      }
    },{//登录页
      path: '/login', name: 'Login', component: Login,
      meta: {
        auth: false,
      }
    },{//预览打印
      path: '/printPreview', name: 'PrintPreview', component: PrintPreview,
      meta: {
        auth: false,
        owner: [leaderUserCode, easUserCode],
      }
    },{//餐饮二维码
      path: '/cateringQrcode', name: 'CateringQrcode', component: CateringQrcode,
      meta: {
        auth: false,
        owner: [leaderUserCode, easUserCode,cateringCode],
      }
    },{//数据驾驶舱内容
      path: '/dashboardContent', name: 'DashboardContent', component: DashboardContent,
      meta: {
        auth: false,
        owner: [leaderUserCode, easUserCode],
      }
    },{//数据驾驶舱内容PC 
      path: '/dashboardContentPC', name: 'DashboardContentPC', component: DashboardContentPC,
      meta: {
        auth: false,
        owner: [leaderUserCode, easUserCode],
      }
    },{//主页面
      path: '/', name: 'MainView', component: MainView,
      meta: {
        auth: true,
      },
      children: [
        /**
         * 教务
         */
        {//教务首页
          path: '/index', name: 'Index', component: Index,
          meta: {
            auth: true,
            owner: [leaderUserCode, easUserCode],
          }
        },{//我的任务-教务
          path: '/task', name: 'Task', component: Task,
          meta: {
            auth: true,
            owner: [leaderUserCode, easUserCode],
          }
        },{//班级管理
          path: '/class', name: 'Class', component: Class,
          meta: {
            auth: true,
            owner: [leaderUserCode, easUserCode],
          }
        },{//数据驾驶舱
          path: '/dashboard', name: 'Dashboard', component: Dashboard,
          meta: {
            auth: true,
            owner: [leaderUserCode, easUserCode],
          }
        },{//课题征集管理
          path: '/researchCollection', name: 'ResearchCollection', component: ResearchCollection,
          meta: {
            auth: false,
            owner: [leaderUserCode, easUserCode],
          },
          children: [

          ]
        },
        {//课题征集反馈
          path: '/researchFeedback1', name: 'ResearchFeedback1', component: ResearchFeedback1,
          meta: {
            auth: false,
            parentPath: 'researchCollection',
            owner: [leaderUserCode, easUserCode],
          }
        },{//课题征集
          path: '/researchFeedback', name: 'ResearchFeedback', component: ResearchFeedback,
          meta: {
            auth: false,
            owner: [leaderUserCode, easUserCode],
          }
        },{//班级管理详情页
          path: '/classDetails', name: 'ClassDetails', component: ClassDetails,
          meta: {
            auth: true,
            parentPath: '/class',
            owner: [leaderUserCode, easUserCode],
          },
          children: [
            {//开班信息
              path: '/openClassMessage', name: 'OpenClassMessage', component: OpenClassMessage,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode, easUserCode],
              }
            },{//学员名单
              path: '/studentList', name: 'StudentList', component: StudentList,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode, easUserCode],
              }
            },{//培训日程
              path: '/trainingSchedule', name: 'TrainingSchedule', component: TrainingSchedule,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode, easUserCode],
              }
            },{//作业安排
              path: '/homeworkArrange', name: 'HomeworkArrange', component: HomeworkArrange,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode, easUserCode],
              }
            },{//班级资源
              path: '/classResources', name: 'ClassResources', component: ClassResources,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode, easUserCode],
              }
            },{//作业管理-教务
              path: '/homeworkManage', name: 'HomeworkManage', component: HomeworkManage,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode, easUserCode],
              }
            },{//考勤情况
              path: '/attendanceSituation', name: 'AttendanceSituation', component: AttendanceSituation,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode, easUserCode],
              }
            },{//教学评估
              path: '/teachingEvaluation', name: 'TeachingEvaluation', component: TeachingEvaluation,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode],
              }
            },{//结业评估
              path: '/clazzEvaluation', name: 'ClazzEvaluation', component: ClazzEvaluation,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode],
              }
            },{//作业成绩
              path: '/homeworkScore', name: 'HomeworkScore', component: HomeworkScore,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode, easUserCode],
              }
            },{//班级相册
              path: '/classAlbum', name: 'ClassAlbum', component: ClassAlbum,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode, easUserCode],
              }
            },{//班级二维码生成
              path: '/qrCode', name: 'QrCode', component: QrCode,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode, easUserCode],
              }
            },{//课时统计（已结业）
              path: '/courseStatistics', name: 'CourseStatistics', component: CourseStatistics,
              meta: {
                auth: true,
                parentPath: '/class',
                owner: [leaderUserCode, easUserCode],
              }
            },
          ]
        },{//移动课堂
          path: '/classRoom', name: 'ClassRoom', component: ClassRoom,
          meta: {
            auth: true,
            owner: [leaderUserCode, easUserCode],
          }
        },{//信息管理
          path: '/message', name: 'Message', component: Message,
          meta: {
            auth: true,
            owner: [leaderUserCode, easUserCode],
          }
        },{//信息详情
          path: '/messageDetails', name: 'MessageDetails', component: MessageDetails,
          meta: {
            auth: true,
            parentPath: '/message',
            owner: [leaderUserCode, easUserCode],
          }
        },{//信息发送
          path: '/writeMsg', name: 'WriteMsg', component: WriteMsg,
          meta: {
            auth: true,
            parentPath: '/message',
            owner: [leaderUserCode, easUserCode],
          }
        },{//相关设置
          path: '/setting', name: 'Setting', component: Setting,
          meta: {
            auth: true,
            owner: [leaderUserCode, easUserCode],
          },
          children: [
            {//教学地点设置
              path: '/placeSetting', name: 'PlaceSetting', component: PlaceSetting,
              meta: {
                auth: true,
                parentPath: '/setting',
                owner: [leaderUserCode, easUserCode],
              }
            },{//干部教学培训质量评估
              path: '/suggestionsSetting', name: 'SuggestionsSetting', component: SuggestionsSetting,
              meta: {
                auth: true,
                parentPath: '/setting',
                owner: [leaderUserCode, easUserCode],
              }
            },{//干部培训课程质量评估标准
              path: '/questionnaireSetting', name: 'QuestionnaireSetting', component: QuestionnaireSetting,
              meta: {
                auth: true,
                parentPath: '/setting',
                owner: [leaderUserCode, easUserCode],
              }
            },{//信息设置
              path: '/msgSetting', name: 'MsgSetting', component: MsgSetting,
              meta: {
                auth: true,
                parentPath: '/setting',
                owner: [leaderUserCode, easUserCode],
              }
            },
          ]
        },{//师资库
          path: '/teacherManageParent', name: 'TeacherManageParent', component: TeacherManageParent,
          meta: {
            auth: true,
            owner: [leaderUserCode, easUserCode],
          },
          children: [
            {//校内教师
              path: '/teacherManage', name: 'TeacherManage', component: TeacherManage,
              meta: {
                auth: true,
                owner: [leaderUserCode, easUserCode],
              }
            },{//外聘教师
              path: '/teacherManageOutside', name: 'TeacherManageOutside', component: TeacherManageOutside,
              meta: {
                auth: true,
                owner: [leaderUserCode, easUserCode],
              }
            }
          ]
        },{//课程库
          path: '/courseManage', name: 'CourseManage', component: CourseManage,
          meta: {
            auth: true,
            owner: [leaderUserCode, easUserCode],
          }
        },
        {//工作量统计
          path: '/workloadStatistics', name: 'WorkloadStatistics', component: WorkloadStatistics,
          meta: {
            auth: true,
            owner: [leaderUserCode, easUserCode],
          },
          redirect:'/studyTrainingDetailsStatistics',
          children:[
            {//学习培训详情统计
              path: '/studyTrainingDetailsStatistics', name: 'StudyTrainingDetailsStatistics', component: StudyTrainingDetailsStatistics,
              meta: {
                auth: true,
                parentPath: '/workloadStatistics',
                owner: [leaderUserCode, easUserCode],
              },
            },{//课时统计
              path: '/classStatistics', name: 'ClassStatistics', component: ClassStatistics,
              meta: {
                auth: true,
                parentPath: '/workloadStatistics',
                owner: [leaderUserCode, easUserCode],
              }
            },{//专题查询
              path: '/topicFind', name: 'TopicFind', component: TopicFind,
              meta: {
                auth: true,
                parentPath: '/workloadStatistics',
                owner: [leaderUserCode, easUserCode],
              }
            },{//专题查询
              path: '/attendanceTeacher', name: 'AttendanceTeacher', component: AttendanceTeacher,
              meta: {
                auth: true,
                parentPath: '/workloadStatistics',
                owner: [leaderUserCode, easUserCode],
              }
            },{//课时统计
              path: '/externalTeacherStatistics', name: 'ExternalTeacherStatistics', component: ExternalTeacherStatistics,
              meta: {
                auth: true,
                parentPath: '/workloadStatistics',
                owner: [leaderUserCode, easUserCode],
              }
            },{//课时统计(领导)
              path: '/teachingEvaluationAll', name: 'TeachingEvaluationAll', component: TeachingEvaluationAll,
              meta: {
                auth: true,
                parentPath: '/workloadStatistics',
                owner: [leaderUserCode, easUserCode],
              }
            },{//课时统计(领导)
              path: '/teachingEvaluationOutside', name: 'teachingEvaluationOutside', component: TeachingEvaluationOutside,
              meta: {
                auth: true,
                parentPath: '/workloadStatistics',
                owner: [leaderUserCode, easUserCode],
              }
            }
          ]
        },{//学习培训管理
          path: '/trainingManage', name: 'TrainingManage', component: TrainingManage,
          meta: {
            auth: true,
            owner: [leaderUserCode, easUserCode],
          }
        },
        {//考勤管理
          path: '/attendanceManagement', name: 'AttendanceManagement', component: AttendanceManagement,
          meta: {
            auth: true,
            owner: [manageCode],
          }
        },
        {//考勤管理/培训日程
          path: '/attendanceSchedule', name: 'AttendanceSchedule', component: AttendanceSchedule,
          meta: {
            auth: true,
            owner: [leaderUserCode],
          }
        },
        /**
         * 学员
         */
        {//学员首页
          path: '/index_stu', name: 'IndexStu', component: IndexStu,
          meta: {
            auth: true,
            owner: [studentUserCode],
          }
        },{//我的任务-学员
          path: '/task_stu', name: 'TaskStu', component: TaskStu,
          meta: {
            auth: true,
            owner: [studentUserCode],
          }
        },{//作业管理-学员
          path: '/homeworkManage_stu', name: 'HomeworkManageStu', component: HomeworkManageStu,
          meta: {
            auth: true,
            owner: [studentUserCode],
          }
        },
        /**
         * 教师批改
         */
        {//批改老师首页
          path: '/index_tea', name: 'IndexTea', component: IndexTea,
          meta: {
            auth: true,
            owner: [teacherUserCode,teacherClassUserCode],
          }
        },{//我的任务-批改教师
          path: '/task_tea', name: 'TaskTea', component: TaskTea,
          meta: {
            auth: true,
            owner: [teacherUserCode,teacherClassUserCode],
          }
        },{//作业管理-批改教师
          path: '/homeworkManage_tea', name: 'HomeworkManageTea', component: HomeworkManageTea,
          meta: {
            auth: true,
            owner: [teacherUserCode,teacherClassUserCode],
          }
        },{//课程管理-批改教师
          path: '/lessonManage', name: 'CourseManageTea', component: CourseManageTea,
          meta: {
            auth: true,
            owner: [teacherUserCode,teacherClassUserCode],
          }
        },{//作业管理详情-批改教师
          path: '/hmDetails_tea', name: 'HomeworkManageDetailsTea', component: HomeworkManageDetailsTea,
          meta: {
            auth: true,
            parentPath: '/homeworkManage_tea',
            owner: [teacherUserCode,teacherClassUserCode],
          }
        },{//班级管理
          path: '/classTea', name: 'ClassTea', component: ClassTea,
          meta: {
            auth: true,
            owner: [teacherUserCode,teacherClassUserCode],
          }
        },{//班级管理详情页
          path: '/classDetailsTea', name: 'ClassDetailsTea', component: ClassDetailsTea,
          meta: {
            auth: true,
            parentPath: '/classTea',
            owner: [teacherUserCode,teacherClassUserCode],
          },
          children: [
            {//开班信息
              path: '/openClassMessageTea', name: 'OpenClassMessageTea', component: OpenClassMessageTea,
              meta: {
                auth: true,
                parentPath: '/classTea',
                owner: [teacherUserCode,teacherClassUserCode],
              }
            },{//学员名单
              path: '/studentListTea', name: 'StudentListTea', component: StudentListTea,
              meta: {
                auth: true,
                parentPath: '/classTea',
                owner: [teacherUserCode,teacherClassUserCode],
              }
            },{//培训日程
              path: '/trainingScheduleTea', name: 'TrainingScheduleTea', component: TrainingScheduleTea,
              meta: {
                auth: true,
                parentPath: '/classTea',
                owner: [teacherUserCode,teacherClassUserCode],
              }
            },{//作业成绩
              path: '/homeworkScoreTea', name: 'HomeworkScoreTea', component: HomeworkScoreTea,
              meta: {
                auth: true,
                parentPath: '/classTea',
                owner: [teacherUserCode,teacherClassUserCode],
              }
            },{//作业成绩
              path: '/qrCodeTea', name: 'QrCodeTea', component: QrCodeTea,
              meta: {
                auth: true,
                parentPath: '/classTea',
                owner: [teacherUserCode,teacherClassUserCode],
              }
            }
          ]
        },
        //餐饮管理
        {//菜单管理
          path: '/cateringMenu', name: 'CateringMenu', component: CateringMenu,
          meta: {
            auth: true,
            owner: [teacherUserCode, teacherClassUserCode,cateringCode],
          },
        },{//今日菜单
          path: '/cateringToday', name: 'CateringToday', component: CateringToday,
          meta: {
            auth: true,
            owner: [teacherUserCode, teacherClassUserCode,cateringCode],
          },
        },{//餐饮记录
          path: '/cateringRecord', name: 'CateringRecord', component: CateringRecord,
          meta: {
            auth: true,
            owner: [teacherUserCode, teacherClassUserCode,cateringCode],
          },
        },
        {//图书馆
          path: '/library', name: 'Library', component: Library,
          meta: {
            auth: false
          },
        },
        {//直播课
          path: '/lessonLive', name: 'LessonLive', component: LessonLive,
          meta: {
            auth: false
          },
        },
        {//课题管理
          path: '/researchManage', name: 'Research', component: Research,
          meta: {
            auth: true,
            owner:["researchrole", "teacherUserCode"]
          },
        },
        {//课题管理
          path: '/myResearch', name: 'ResearchTeacher', component: ResearchTeacher,
          meta: {
            auth: true,
            owner:[teacherUserCode,teacherClassUserCode]
          },
        },
        // {//班级管理
        //   path: '/classTea', name: 'ClassTea', component: ClassTea,
        //   meta: {
        //     auth: true,
        //     owner: [teacherUserCode,teacherClassUserCode],
        //   },
        // }, {//班级管理详情页
        //   path: '/classDetailsTea', name: 'ClassDetailsTea', component: ClassDetailsTea,
        //   meta: {
        //     auth: true,
        //     parentPath: '/classTea',
        //     owner: [teacherUserCode, teacherClassUserCode],
        //     children: [
        //       {//开班信息
        //         path: '/openClassMessageTea', name: 'OpenClassMessageTea', component: OpenClassMessageTea,
        //         meta: {printPreview
        //           auth: true,
        //           parentPath: '/classTea',
        //           owner: [teacherUserCode, teacherClassUserCode],
        //         }
        //       }
        //     ]
        //   },
        // }
      ]
    }
  ],
  // mode: 'history',//发布时需要改为'hash'（默认hash模式）
  // base: '/school/'
  base: '/#/'
});



// WEBPACK FOOTER //
// ./src/router/index.js